/*
 *    Controller to show an invoice 
 *    Triggered via:
 *        Radio.request(
 *          'show_invoice',
 *          {{ID}}
 *        );
 *    Arguments:
 *        ID: String. Unique ID of an invoice
*/

import Radio from 'backbone.radio';
import InvoiceView from '@/views/invoice';
import BreadcrumbNavLayout from '@/views/breadcrumb_nav_layout';

const  globalCh = Radio.channel('global');
const  routerCh = Radio.channel('router');
const  apiCh = Radio.channel('api');

function show_invoice(id) {
    const invoices = apiCh.request('invoice');
    let invoice;

    invoices.fetch()
    .then(()=>{
        invoice = apiCh.request('invoice', id);
        if ( invoice === undefined ) {    
            globalCh.request('not_found', 'Sorry, we couldn\'t find that invoice');
            return false;
        }

        let account = globalCh.request('primary_account');
        let app_container = globalCh.request('app_layout');

        let invoice_view = new InvoiceView({
            model: invoice,
        });

        app_container.showChildView('container', invoice_view);

        globalCh.request('show_secondary_nav', { empty: true });
        globalCh.request('show_profile_nav', { selected: 'account-billing' });
        routerCh.request('set_location', 'invoice', account, invoice );

        app_container.showChildView('main_nav', new BreadcrumbNavLayout());

        globalCh.request('changeActiveAccount', account, function () {
            globalCh.request('set_selection', {
                type: 'app',
                id: 'home'
            });
        });
    });    
}

export default show_invoice;



